"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const types_1 = require("../../types");
const getContainerWidth = ({ theme, size, fullWidth }) => {
    if (fullWidth) {
        return '100%';
    }
    if (typeof size === 'number') {
        return `${size}px`;
    }
    if (size === types_1.progressBarSize.small) {
        return theme.widthProgressBarSmall;
    }
    if (size === types_1.progressBarSize.large) {
        return theme.widthProgressBarLarge;
    }
    if (size === types_1.progressBarSize.default) {
        return theme.widthProgressBarDefault;
    }
    return size;
};
const ProgressBarContainer = styled_components_1.default.div `
  display: inline-block;
  max-width: ${getContainerWidth};
  min-width: ${({ theme }) => theme.widthProgressBarSmall};
  width: ${({ theme }) => theme.widthProgressBarLarge};
`;
exports.default = ProgressBarContainer;
